import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { logout as actionLogout, refreshAuthToken } from "../actions/session";
import * as profileActions from "../actions/profile";
import * as folderActions from "../actions/folders";
import utf8 from "utf8";

const useAuth = ({ history, listingID }) => {
  const dispatch = useDispatch();

  const refreshToken = useCallback(() => {
    dispatch(refreshAuthToken());
  }, [dispatch]);

  const logout = useCallback(() => {
    dispatch(actionLogout());
  }, [dispatch]);

  const onSuccess = useCallback(() => {
    dispatch(profileActions.fetchProfile());
    dispatch(profileActions.fetchMyAgentProfile());
    dispatch(profileActions.fetchRecommendedVendors());
    dispatch(profileActions.fetchSystemSettingsUrls());
    dispatch(folderActions.fetchFolders());
    const { pathname } = window.location;
    const { encode } = utf8;
    /**
     * Should match: "/public", "/publicportal", "/public-portal", etc.
     */
    const redirectPathName = pathname.replace(/(\/public)[-]*(portal)*/g, "");
    let redirectURL = encode(redirectPathName);
    const isSearchURL = redirectURL?.includes("search");
    if (isSearchURL && listingID) redirectURL = `${redirectURL}/${listingID}`;
    history.push(redirectURL);
  }, [dispatch, history, listingID]);

  return { refreshToken, logout, onSuccess };
};

export default useAuth;